<template>
    <v-card>
        <v-card-title>
            <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="editedItem.codigo" label="Codigo Cliente *"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="editedItem.nit" label="Nit *" @change="findClienteSat"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="editedItem.nombre" label="Nombre *"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="editedItem.direccion" label="Direccion *"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="editedItem.telefono" label="Telefono"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="8" md="8">
                        <v-text-field v-model="editedItem.email" label="Correo"></v-text-field>
                    </v-col>
                    <!--                   
                  <v-col cols="12">
                    <v-switch
                      v-model="editedItem.condicion"
                      :label="editedItem.condicion ==1 ? 'Activado' :'Desactivado'"
                      color="green"
                      :value="editedItem.condicion ==1 ? editedItem.condicion=1 : editedItem.condicion=0"
                      hide-details                   
                    ></v-switch>              
                  </v-col>   
                  -->
                </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="save" dark>Guardar</v-btn>
            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import Swal from "sweetalert2";
import axios from "axios";
import findClienteSat from './utils/find.cliente'
import { mapGetters } from "vuex";

export default {
    props:['dataitem'],
    name:"CrearEditarPersona",

    data: () => ({
    
        editedIndex: -1,
        editedItem: {
            codigo:'CC-001',
            nombre: "",
            nit: "",
            direccion: "",
            email: "",
            telefono: "",
        },
        defaultItem: {
            codigo:'CC-001',
            nombre: "",
            nit: "",
            direccion: "",
            email: "",
            telefono: "",
        },
    }),
    created(){
        this.main();
    },
    computed:{
        ...mapGetters(["getTokenUser","getClientePorId"]),
        formTitle() {
           return this.editedIndex === -1 ? "Nuevo Registro" : "Editar Registro";
        },
    },
    methods:{

        async main () {
    
            const id = parseInt(this.$route.params.id)
            if(id){
                //const item = this.$store.getters.getClientePorId(id)
                const item = this.getClientePorId(id)
                this.editedIndex = item.idpersona
                this.editedItem = Object.assign({}, item);
            }      
        },

        async findClienteSat(){
            this.editedItem.nit = this.editedItem.nit.trim() //Quitamos espacios en blanco
            this.editedItem.nit = this.editedItem.nit.replace(/-/, '')

            //if(this.editedIndex<0){

                try {
                    const cliente = await findClienteSat(this.editedItem.nit) 
                    this.editedItem.nombre = cliente
                } catch (er) {
                     //Swal.fire('Error en NIT','Verifique el Nit en el portal de la SAT haciendo click en el siguiente enlace','error')
                     Swal.fire({
                        icon: 'error',
                        title: 'Error al obtener nombre asociado al NIT',
                        text: 'Porfavor Verifique el Nit ⬇',
                        showCloseButton: true,
                        showConfirmButton:false,
                        footer: '<a href="https://cdn.c.sat.gob.gt/rtu/consulta-cui-nit" target="_blank"><b>Verificar NIT Aquí</b></a>'
                     })
                    console.log(er)
                }
            
           // }
        
        },

        close() {
            //this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
            this.$router.go(-1)
        },

        async save() {
        if (this.editedIndex > -1) {
            await this.putItem();
        } else {
            await this.postItem();
        }
            this.close();
        },
        async postItem() {
            await this.$store.dispatch('createCliente',this.editedItem) 
            await this.$store.dispatch('setClientes')  
        },
        async putItem() {
            try {
                await axios.put(`${this.$store.state.urlapi}/personas/${this.editedItem.idpersona}`,this.editedItem,this.getTokenUser)
                await this.$store.dispatch('setClientes')  
                Swal.fire({
                    icon: "success",
                    title: "Realizado",
                    showConfirmButton: false,
                    timer: 1500,
                });
               
            } catch (error) {
                console.log(error)
                Swal.fire('Opps ocurrio un error','Error al procesar su solicitud','error')
            }

            
        },
    }
}


</script>